import { formatToastErrors } from "@utils/toast-errors";
import { instance } from "./helpers/axios";

export const getQuestionsForProducts = async (productIds: string[]) => {
  try {
    const responses = await Promise.all(
      productIds.map(
        async (id) =>
          await instance.get("/questions", {
            params: {
              product: id,
            },
          })
      )
    );

    return responses.map((res) => res.data.result);
  } catch (err: any) {
    throw formatToastErrors(err);
  }
};
export const getQuizResults = async (externalId: string, productId: string) => {
  try {
    const response = await instance.get("/quiz-result", {
      params: {
        external_id: externalId,
        product: productId,
      },
    });
    return response.data;
  } catch (err: any) {
    throw formatToastErrors(err);
  }
};
export const getPresetPriceForAovProduct = async (product: string) => {
  try {
    const responses = await instance.get(
      `/insurance-products/${product}/preset-prices`
    );

    return responses.data;
  } catch (err: any) {
    throw formatToastErrors(err);
  }
};

export const getConsumerInsuranceQuotes = async (product: string) => {
  try {
    const responses = await instance.post("/allianz/create-quote", {
      product,
      get_cross_sell_products: true,
    });

    return responses.data;
  } catch (err: any) {
    const code =
      err.response?.data?.rejected_reason?.error_code ??
      err.response?.data?.allianz_consumer?.rejected_reason?.error_code;
    throw {
      message: formatToastErrors(err),
      ...(err.response?.status === 400 && {
        failed: true,
        code,
      }),
    };
  }
};
